/**
 * @description 应用环境
 * dev
 * test
 * production
 */

export const Env = {
  Production: !/test|localhost|10.20/.test(window.location.host)
  // Production: true
  // Production: !/test|localhost|10.20/.test(window.location.host)
}
